// extracted by mini-css-extract-plugin
export default {"StaticDiffPreview":"StaticUnifiedDiffPreview-module__StaticDiffPreview__dZfZXRH","HeaderContainer":"StaticUnifiedDiffPreview-module__HeaderContainer__Y7SRj3J"};